import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { WorksheetChartSection, WorksheetResultsSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { ResultsMessagesSection } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import React from 'react';
import ResultsCalculatedPropertiesSection from './ResultsCalculatedPropertiesSection';
import ResultsChartOptionsSection from './ResultsChartOptionsSection';
import ResultsReportOptionsSection from './ResultsReportOptionsSection';

let ResultsPageSection: React.FC<IWorksheetComponent> = () => (
  <WorksheetResultsSection heading="Results">
    <ResultsChartOptionsSection />
    <NamePrefixModifier namePrefix="chart">
      <WorksheetChartSection wide />
    </NamePrefixModifier>
    <ResultsMessagesSection />
    <ResultsCalculatedPropertiesSection />
    <ResultsReportOptionsSection />
  </WorksheetResultsSection>
);

ResultsPageSection = withInjectedProps(ResultsPageSection);

export { ResultsPageSection };
export default ResultsPageSection;
